import React from 'react';

/**
 * Compact EDVise speech bubble (matches tutorial / paper-menu guide styling).
 */
function AbilitySpeechBubble({ children, placement = 'top', align = 'end' }) {
  const positionClass =
    placement === 'top'
      ? `bottom-full mb-2 ${align === 'end' ? 'right-0' : 'left-0'}`
      : `top-full mt-2 ${align === 'end' ? 'right-0' : 'left-0'}`;

  const arrowHorizontal = align === 'end' ? 'right-4' : 'left-4';
  const arrowClass =
    placement === 'top'
      ? `bottom-[-6px] ${arrowHorizontal} border-b border-r`
      : `top-[-6px] ${arrowHorizontal} border-t border-l`;

  return (
    <div
      className={`absolute z-10 w-max max-w-[11.5rem] pointer-events-none ${positionClass}`}
      aria-hidden
    >
      <div className="relative bg-surface rounded-xl shadow-lg border border-edge px-3 py-2 text-left">
        <div
          className={`absolute w-2.5 h-2.5 bg-surface border-edge rotate-45 ${arrowClass}`}
        />
        <p className="text-xs font-medium text-ink leading-snug text-justify">{children}</p>
      </div>
    </div>
  );
}

export default AbilitySpeechBubble;
